import React from 'react';
import eventFormatter from '#component/device/event-formatter';
import eventIcon from '#component/icon/event';
import { EventCnt, EventIcon, EventTitle, EventLink } from '#component/shipment/overview/devices-list/device-info/styles';

function DashboardEvent(props) {
  const {
    device: { lastEvent = {} },
    account,
    getTabUrl
  } = props;
  if (!lastEvent.identifier) {
    return null;
  }
  return (
    <EventCnt>
      <EventLink
        to={{
          pathname: getTabUrl(90, lastEvent.timestamp)
        }}
      >
        <EventIcon>
          {eventIcon(lastEvent)}
        </EventIcon>
        <EventTitle>
          {eventFormatter(lastEvent, account)}
        </EventTitle>
      </EventLink>
    </EventCnt>
  );
}

export default DashboardEvent;
